import "./style.scss"
import React, { useEffect } from 'react';
import { Button, InputGroup, Row, Col } from 'react-bootstrap-v5';
import DropdownTreeSelect, { TextProps } from 'react-dropdown-tree-select';
import { useTranslation } from 'react-i18next';
import { ServiceTreeNode } from '../../../../../../utils/common/models';
import { KTSVG } from "../../../../../../utils/helpers";


type Props = {
    data: ServiceTreeNode[],
    onChange?: (data: ServiceTreeNode[]) => void,
    onSelectedSubSubService?: (selectedNodes: ServiceTreeNode[]) => void,
    isShowSelectAll?: boolean,
    placeholder?: string
    inlineSearchPlaceholder?: string
    isSelectOnlyService?: boolean,
    rtlMode?: boolean
    disabled?: boolean
}


const TreeServiceUser: React.FC<Props> = ({
    data,
    onChange,
    onSelectedSubSubService,
    isShowSelectAll = true,
    placeholder,
    inlineSearchPlaceholder,
    isSelectOnlyService = false,
    rtlMode = false,
    disabled = false
}) => {
    const { t } = useTranslation();

    const texts = {
        placeholder: t(placeholder || 'USERS_PAGE.CONTENT_STEP.SELECT_SERVICE'),
        inlineSearchPlaceholder: t(inlineSearchPlaceholder || 'USERS_PAGE.CONTENT_STEP.SEARCH_SERVICE'),
    } as TextProps
    if (!data) return <></>

    const onChangeService = (currentNode: ServiceTreeNode, selectedNodes: ServiceTreeNode[]) => {
        // Inactive nodes are a one-way toggle: an already-checked one (kept visible because
        // it was selected before going inactive) can still be unchecked to remove it, but
        // can't be checked again - it isn't bookable.
        if (currentNode.isAvailable === false && currentNode.checked) {
            currentNode.checked = false;
        }

        let newData = [...data];
        let subSubSelected = [] as ServiceTreeNode[];

        // if isSelectOnlyService is true, uncheck all other services when selecting any node from a different service
        if (isSelectOnlyService && currentNode.checked) {
            newData.forEach(majorNode => {
                if (majorNode.majorId !== currentNode.majorId) {
                    majorNode.checked = false;
                    majorNode.expanded = false;
                    majorNode.children?.forEach(subNode => {
                        subNode.checked = false;
                        subNode.expanded = false;
                        subNode.children?.forEach(subSubNode => {
                            subSubNode.checked = false;
                            subSubNode.expanded = false;
                        });
                    });
                }
            });
        }

        // handle click on major tree data
        newData.forEach(majorNode => {
            if (majorNode.majorId === currentNode.majorId) {
                //majorNode.checked = true;
                // Checked sub service
                majorNode.expanded = true;
                majorNode.children?.forEach(subNode => {

                    subNode.expanded = true;
                    subNode.children?.forEach(subSubNode => {
                        subSubNode.expanded = true;
                        if (subSubNode.isAvailable === false) {
                            if (subSubNode.checked) subSubSelected.push(subSubNode);
                            return;
                        }
                        // checked major and sub and sub sub
                        switch (true) {
                            case currentNode.isMajor:
                                subSubNode.checked = currentNode.checked;
                                break;

                            case currentNode.isSub && subSubNode.subId == currentNode.subId:
                                subSubNode.checked = currentNode.checked;
                                break;

                            case currentNode.isSubSub && currentNode.subSubId === subSubNode.subSubId:
                                subSubNode.checked = currentNode.checked;
                                break;
                            default:
                                break;
                        }

                        if (subSubNode.checked) subSubSelected.push(subSubNode);
                    });
                });
            } else {
                // if not selecting only one service, collapse other major nodes
                if (!isSelectOnlyService) {
                    majorNode.expanded = false;
                    majorNode.children?.forEach(subNode => {
                        subNode.expanded = false;
                        subNode.children?.forEach(subSubNode => {
                            subSubNode.expanded = false;
                            if (subSubNode.checked) subSubSelected.push(subSubNode);
                        });
                    });
                } else {
                    // for single service selection, keep existing checked items from other services
                    majorNode.children?.forEach(subNode => {
                        subNode.children?.forEach(subSubNode => {
                            if (subSubNode.checked) subSubSelected.push(subSubNode);
                        });
                    });
                }
            }
        });
        onChange?.(newData);
        onSelectedSubSubService?.(subSubSelected);
    }


    const handleSelectedAll = () => {
        let newData = [...data];
        let subSubSelected = [] as ServiceTreeNode[];

        // handle click on major tree data
        newData.forEach(majorNode => {

            majorNode.expanded = false;
            majorNode.children?.forEach(subNode => {

                subNode.expanded = false;
                subNode.children?.forEach(subSubNode => {
                    subSubNode.checked = true;
                    subSubNode.expanded = false;
                    subSubSelected.push(subSubNode);
                });
            });

        });
        onChange?.(newData);
        onSelectedSubSubService?.(subSubSelected);
    }

    const handleUnSelectedAll = () => {
        let newData = [...data];

        // handle click on major tree data
        newData.forEach(majorNode => {

            majorNode.expanded = false;
            majorNode.checked = false;
            majorNode.children?.forEach(subNode => {

                subNode.checked = false;
                subNode.expanded = false;
                subNode.children?.forEach(subSubNode => {
                    subSubNode.checked = false;
                    subSubNode.expanded = false;
                });
            });

        });
        onChange?.(newData);
        let subSubSelected = [] as ServiceTreeNode[];
        onSelectedSubSubService?.(subSubSelected);
    }



    return <Row>
        <Col xl={isShowSelectAll ? 8 : 12} className="mb-3">
            <InputGroup className='filter-calender'>
                <InputGroup.Text id='basic-addon1'>
                    <KTSVG defaultColor={true} path="/assets/images/icons/service-and-skill.svg" />
                </InputGroup.Text>
                <div className='select-service1 flex-root'>
                    <DropdownTreeSelect
                        data={data}
                        className={`service-tree1 ${rtlMode ? "service-tree-rtl" : ""}`}
                        onChange={onChangeService}
                        inlineSearchInput
                        keepTreeOnSearch
                        showPartiallySelected
                        disabled={disabled}
                        texts={texts}
                    />
                </div>
            </InputGroup>
        </Col>
        {isShowSelectAll && <Col xl={4} className="mb-3">
            <div className='button-action-select-service'>
                <Button variant='secondary' className='rounded w-150px h-50px' onClick={handleSelectedAll}>{t('USERS_PAGE.CONTENT_STEP.SELECT_ALL')}</Button>
                <Button variant='secondary' className='mx-2 rounded w-150px h-50px' onClick={handleUnSelectedAll}>{t('USERS_PAGE.CONTENT_STEP.UNSELECT_ALL')}</Button>
            </div>
        </Col>}

    </Row>
}

export { TreeServiceUser }